import { onEventCategory } from './events'
import { supabase } from './supabase'

// Maps Mori event names to content_interactions.interaction_type values
const EVENT_TO_INTERACTION: Record<string, string> = {
  'card.shown':       'shown',
  'card.tapped':      'yes_tapped',
  'card.dismissed':   'dismissed',
  'card.swiped_past': 'swiped_past',
  'challenge.completed': 'challenge_completed',
}

// Stable session ID for the lifetime of this page session
const SESSION_ID = crypto.randomUUID()

// Deduplication for card.shown — insert only once per session per card
const shownThisSession = new Set<string>()

export function initContentInteractionSubscriber(): void {
  onEventCategory('card', (event, payload) => {
    const p = payload as Record<string, unknown>
    const interactionType = EVENT_TO_INTERACTION[event]
    if (!interactionType) return

    const userId = p.userId as string
    const contentId = p.contentLibraryId as string

    // Deduplicate shown events — one insert per card per session
    if (event === 'card.shown') {
      if (shownThisSession.has(contentId)) return
      shownThisSession.add(contentId)
    }

    // Fire-and-forget — same pattern as the original trackInteraction
    supabase
      .from('content_interactions')
      .insert({
        user_id: userId,
        content_id: contentId,
        interaction_type: interactionType,
        session_id: SESSION_ID,
        session_date: new Date().toISOString().split('T')[0],
      })
      .then(({ error }) => {
        if (error) console.warn('[interactions] insert failed:', error.message)
      })
  })
}
